module.exports = __webpack_public_path__ + "img/dental2.061a7574.jpeg";